import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'hooks'
import { validationSchema } from 'schema/inviteUser'
import { useGetUserQuery } from 'services/user'
import { getExpiryDays } from 'utils/datetime'
import { mappedLanguages } from 'features/auth/appSlice'
import { getSalutationByCode, getCountryByCode } from 'utils/helpers'
import { FormContainer, Input } from 'components/Form'
import { Loader } from 'components/Loaders'
import { Badge, BadgeWithText } from 'components/Form/Static'
import Modal from 'components/Modals'
import { DialogBox } from 'components/Zui'

const UserDetails = ({ onClose, email }) => {
    const { t } = useIntl()
    const lang = useSelector(mappedLanguages)

    const { data, isLoading } = useGetUserQuery(email, { skip: !email })

    if (data) {
    }

    const getLangByCode = code => {
        return lang && lang.find(l => l.value === code)
    }

    return (
        <Modal>
            <FormContainer
                initialValues={{
                    title: data ? getSalutationByCode(data.title)?.label : null,
                    lastName: data?.lastName,
                    firstName: data?.firstName,
                    middleName: data?.middleName,
                    emailId: data?.emailId,
                    language: data ? getLangByCode(data.language)?.label : null,
                    country: data ? getCountryByCode(data.country)?.label : null,
                    status: data?.onboardingStatus,
                }}
                validationSchema={validationSchema(t)}
                enableReinitialize
            >
                {() => {
                    return (
                        <DialogBox
                            closable
                            acceptLabel={t('close')}
                            hideCancelButton
                            onAccept={onClose}
                            headerText={t('user.info.title')}
                            onClose={onClose}
                        >
                            {isLoading && <Loader />}
                            {data && (
                                <div className="user-details-popup-content">
                                    <div className="dialog-content-wrap">
                                        <Input
                                            static
                                            horizontal
                                            label={t('label.title')}
                                            name="title"
                                        />

                                        <Input
                                            static
                                            horizontal
                                            label={t('label.lastname')}
                                            name="lastName"
                                        />

                                        <Input
                                            static
                                            horizontal
                                            label={t('label.firstname')}
                                            name="firstName"
                                        />
                                        <Input
                                            static
                                            horizontal
                                            label={t('label.middlename')}
                                            name="middleName"
                                        />
                                        <Input
                                            static
                                            horizontal
                                            label={t('label.EMAIL.ADDR')}
                                            name="emailId"
                                        />
                                        <Input
                                            name="status"
                                            static
                                            horizontal
                                            badgeState={
                                                data.onboardingStatus === 'Active'
                                                    ? 'ready'
                                                    : 'progress'
                                            }
                                            component={
                                                data.onboardingStatus === 'Active'
                                                    ? Badge
                                                    : BadgeWithText
                                            }
                                            text={`${t('invitation.expires')} ${t('in.x.days', {
                                                days: getExpiryDays(data.createdDateTime),
                                            })}`}
                                        />
                                        <Input
                                            static
                                            horizontal
                                            label={t('label.language')}
                                            name="language"
                                        />
                                        <Input
                                            static
                                            horizontal
                                            label={t('label.country')}
                                            name="country"
                                        />
                                    </div>
                                </div>
                            )}
                        </DialogBox>
                    )
                }}
            </FormContainer>
        </Modal>
    )
}

export default UserDetails
